import { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "@/hooks/use-auth";
import { hasPending2fa } from "@/utils/auth-session";

const AuthGuard = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [previousRoute, setPreviousRoute] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    if (previousRoute !== null) setPreviousRoute(pathname);
  }, [pathname, previousRoute]);

  // A pending 2FA challenge is an auth lock: treat the user as unauthenticated
  // until the OTP is verified, regardless of any token state.
  if (isAuthenticated && !hasPending2fa()) return <>{children}</>;
  return (
    <Navigate to="/session/login" state={{ redirectUrl: previousRoute }} />
  );
};

export default AuthGuard;